import { FieldType } from 'enums/FieldTypeEnums';
import { CategoryOptions } from 'shared/components/CreateProductModal/ProductModalForm';
import { ReactComponent as MapSearch } from 'assets/icons/map-search.svg';
import { ReactComponent as Add } from 'assets/icons/add.svg';
import { ReactComponent as DeleteButton } from 'assets/icons/close_enclosed.svg';
import clsx from 'clsx';
import styles from './farmCreationFlow.module.scss';
import { allowOnlyPercentages } from 'shared/utils/convertFormData';
import { RawMaterialsLayoutDataProps } from './rawMaterialsLayoutData';
import React from 'react';
import { categoryTypeFieldMap } from 'views/Scope3/Category4&9/Category4Layout/category4LayoutData';
import { Category1Types } from 'enums/category1Enums';
import { INGREDIENTS } from 'constants/Scope3Constants/category1.constants';
import { FieldProps } from 'enums/RawMaterialEnums';

export const getOriginsData = (props: RawMaterialsLayoutDataProps) => {
  const {
    type,
    index,
    bestFitRegionOptions,
    removeOrigin,
    originIndex,
    setIsAddRegion,
    loading,
    fetchData,
    isDisabled,
    handleOriginShare,
  } = props;

  const { PACKAGING_MATERIALS } = Category1Types;
  const { LABELS } = INGREDIENTS;
  const {
    FERTILISER_ORIGIN,
    PACKAGING_ORIGIN,
    BEST_FIT_REGION,
    UNIT,
    ORIGIN_SHARE,
  } = LABELS;
  const { REQUEST_REGION } = FieldProps;

  const removeOriginHandler = () => removeOrigin?.(originIndex);
  const handleOpenRequestRegionModal = () => setIsAddRegion?.(true);
  const typeValue = categoryTypeFieldMap[type];
  const originFieldLabel =
    type === PACKAGING_MATERIALS ? PACKAGING_ORIGIN : FERTILISER_ORIGIN;

  return {
    data: [
      {
        type: FieldType.ELEMENT,
        span: 6,
      },
      {
        type: FieldType.LOCATION_MODAL,
        fieldProps: {
          name: `${typeValue}.${index}.origins.${originIndex}.addressLabel`,
          label: originFieldLabel,
          placeholderstring: originFieldLabel,
          type,
          index,
          selectedOriginIndex: originIndex,
          suffix: <MapSearch />,
          onFocus: () =>
            fetchData({
              'input-field':
                originFieldLabel === FERTILISER_ORIGIN
                  ? 'farmbox_ag_commodity_fertilizer_origin'
                  : 'farmbox_ag_commodity_packaging_material_origin',
            }),
          disabled: isDisabled,
        },
        span: 5,
      },
      {
        type: FieldType.SELECT,
        fieldProps: {
          name: `${typeValue}.${index}.origins.${originIndex}.activityMappingRegionSpecId`,
          label: BEST_FIT_REGION,
          placeholderstring: BEST_FIT_REGION,
          showSearch: true,
          filterOption: (inputValue: string, option: CategoryOptions) =>
            option?.label?.toLowerCase().includes(inputValue.toLowerCase()),
          options: bestFitRegionOptions,
          loading: !!loading,
          dropdownRender: (menu: CategoryOptions) => (
            <>
              <div
                className={styles.dropdownCreateButton}
                onClick={handleOpenRequestRegionModal}>
                <Add /> {REQUEST_REGION}
              </div>
              {menu}
            </>
          ),
          onFocus: () =>
            fetchData({
              'input-field':
                'farmbox_ag_commodity_select_best_fit_production_region',
            }),
          disabled: isDisabled,
        },
        span: 5,
      },
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: `${typeValue}.${index}.origins.${originIndex}.share`,
          label: ORIGIN_SHARE,
          placeholderstring: ORIGIN_SHARE,
          onKeyDown: allowOnlyPercentages,
          isNullable: true,
          disabled: isDisabled,
          onChange: handleOriginShare,
        },
        span: 2,
      },
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: `${typeValue}.${index}.origins.${originIndex}.unit`,
          label: UNIT,
          placeholderstring: UNIT,
          value: '%',
          disabled: true,
        },
        span: 3,
      },
      {
        type: FieldType.ELEMENT,
        additionalElement: (
          <div
            className={clsx(styles.deleteContainer, {
              [styles.hideAction]: isDisabled,
            })}
            onClick={removeOriginHandler}>
            <DeleteButton />
          </div>
        ),
        span: 1,
      },
    ],
  };
};
